import { ref } from 'vue';

const scroll = 'scroll';
const tag = 'product-wrapper';
let productWrapper;
let scrollable;

export const isArrowShow = ref(false);
const eventAction = () => {
  if (!scrollable) return;
  const currentScroll = scrollable.scrollTop;
  isArrowShow.value = currentScroll > 300;
};

export const initScrollAction = () => {
  productWrapper = document.getElementById(tag);
  scrollable = document.getElementById(tag);
};
export const addScrollListener = () => {
  console.log(scroll)
  scrollable.addEventListener(scroll, eventAction);
};
export const detachScrollListener = () => {
  scrollable.removeEventListener(scroll, eventAction);
};

export const goToTop = () => {
  scrollable.scrollTo({
    left: 0,
    top:
      document.getElementById(tag).offsetTop -
      document.getElementById(tag).offsetHeight,
    behavior: 'smooth'
  });
};
